// Getters
export const USR_IS_ERROR = "users/stateUsrIsError";
export const USR_IS_LOADING = "users/stateUsrIsLoading";
export const USR_GET_DATA = "users/stateUsrData";
export const USR_GET_FILTER = "users/stateUsrFilter";
export const USR_ACTION_GETALL = "users/actionUsrGetAll";

//Mutations
export const USR_MUTATION_CLEAR_FILTER = "users/stateUsrFilterClear";

// Actions
export const USR_ACTION_FILTER = "users/stateUsrSearchByFilter";
export const USR_ACTION_CLEAR_FILTER = "users/stateUsrFilterClear";
export const USR_ACTION_REFRESH = "users/stateUsrRefresh";
export const USR_ACTION_DELETE = "users/stateUsrDelete";
export const USR_ACTION_ADD_ASSOC = "users/stateUsrAddAssoc";
export const USR_ACTION_RMV_ASSOC = "users/stateUsrRemoveAssoc";



// WEBPACK FOOTER //
// ./src/store/types_user.js